import { observer } from 'mobx-react';
import React from 'react';
import { answerToString } from '../../../../utils/questionUtil';
import { Content, Editor, Info, Item, Label } from '../Item';
import styles from './DateTime.m.sass';
import DateTimeInput from '../../../../components/DateTimeInput';
var DateTime = function DateTime(_ref) {
  var question = _ref.question,
    answer = _ref.answer,
    readOnly = _ref.readOnly,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate,
    disabled = _ref.disabled,
    checkout = _ref.checkout;
  return /*#__PURE__*/React.createElement(Item, {
    checkout: checkout,
    title: question.description
  }, /*#__PURE__*/React.createElement(Content, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Info, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Label, {
    checkout: checkout
  }, question.question)), /*#__PURE__*/React.createElement(Editor, {
    checkout: checkout
  }, readOnly ? /*#__PURE__*/React.createElement("div", {
    className: styles.response
  }, answerToString(question, answer)) : /*#__PURE__*/React.createElement(DateTimeInput, {
    className: styles.control,
    type: question.collect_time ? 'datetime-local' : 'date',
    onChange: onChange,
    disabled: disabled,
    onBlur: onUpdate,
    disallowFuture: question.disallow_future,
    disallowPast: question.disallow_past,
    placeholder: "Text...",
    value: answer
  }))));
};
export default observer(DateTime);
//# sourceMappingURL=index.js.map
